// if (process.env.NODE_ENV === "production") {
//   window.endpoint = "https://lundi-piscine.herokuapp.com";
// } else {
//   window.endpoint = "http://localhost:3000";
// }

// Global Variables
window.moment = require("moment");
window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vueCountryRegionSelect from "vue-country-region-select";
Vue.use(vueCountryRegionSelect);

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper);

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
